import TagClassifications from 'decentralized/TagClassifications.js';
import {shuffle} from 'utils/ShuffleArray.js';
const tagClassifications = new TagClassifications();

const THRESHOLD = 20;
const RATIO = 12;

/**
 * Variety Reduction is the name of the game when dealing
 * with large amounts of organizing data. Some of it may not
 * be useful to the user at that moment. The goal of this
 * module is to reduce the amount of variety shown to the user
 * so they can make informed decisions
 */
class TagVarietyReducer {
    constructor() {
        this.tagToLevel = {};
        this.tagToParent = {};
        this.tagToChildren = {};
        this.loadHierarchy();
    }

    async loadHierarchy() {
        let flat = await tagClassifications.getClassifications();

        let tagToParent = {};
        for (let tag in flat) {
            tagToParent[tag] = this.getParentOfTag(tag, flat);

            for (let i in flat[tag]) {
                let otherTag = flat[tag][i];
                tagToParent[otherTag] = tag;
            }
        }

        this.tagToChildren = flat;
        this.tagToParent = tagToParent;

        this.tagToLevel = {};
        for (let tag in tagToParent) {
            this.tagToLevel[tag] = this.getLevel(tag, tagToParent);
        }
    }

    getAllChildren(parent) {
        let children = this.tagToChildren[parent];
        let all = [];
        for (let i in children) {
            all = all.concat(this.getAllChildren(children[i]));
        }

        return all.concat(children);
    }

    reduce(list, selectedTags) {

        if (list.length <= THRESHOLD) {
            return list;
        }
        let level = 1;
        let checkUndefined = selectedTags.length === 0;
        let isAllTagsQuery = true;

        let allChildren = [];
        for (let i in selectedTags) {
            let tag = selectedTags[i];
            allChildren = allChildren.concat(this.getAllChildren(tag));
            if (this.tagToLevel[tag] === undefined) {
                checkUndefined = true;
            } else {
                isAllTagsQuery = false;
            }
            if (this.tagToLevel[tag] >= level) {
                level = this.tagToLevel[tag];
            }
        }

        if (checkUndefined) {
            level += 2;
        } 

        if (isAllTagsQuery) {
            // case of "All tags"
            return this.filterReduction(list, 2, allChildren, checkUndefined);
        }

        return this.filterReduction(list, level, allChildren, checkUndefined);
    }


    filterReduction(list, level, allChildren, checkUndefined) {
        return list.filter(
            elem =>
                allChildren.indexOf(elem.value) > -1 ||
                this.tagToLevel[elem.value] <= level || (checkUndefined && this.tagToLevel[elem.value] === undefined));
    }

    getLevel(tag, tagToParent) {
        if (tagToParent[tag] === undefined) {
            return 0;
        }

        if (tagToParent[tag] === tag) {
            return 0;
        }
        
        return 1 + this.getLevel(tagToParent[tag], tagToParent);
    }

    getParentOfTag(tag, flatHierarchy) {
        // look through the values of the flatHierarchy
        for (let otherTag in flatHierarchy) {
            let values = flatHierarchy[otherTag];

            if (values.indexOf(tag) > -1) {
                return otherTag;
            }
        }

        return null;
    }
}

export default TagVarietyReducer;
